<!-- START: Replaced Header -->
<!-- Paste the full content from your header.txt file here -->
<header id="mfn-header-template" data-id="158" data-mobile-type="" data-type="absolute"
	class="mfn-header-tmpl mfn-header-main mfn-header-tmpl-absolute mfn-header-body-offset mfn-header-content-overlay mfn-hasSticky mfn-hasMobile mfn-mobile-header-tmpl-fixed mfn-mobile-header-body-offset">
	<!-- full header.txt HTML content goes here -->

	<div class="mfn-builder-content mfn-header-tmpl-builder">
		<div
			class="section mcb-section mfn-header-mobile-section mcb-section-b3fc5e5e3 mcb-header-section close-button-left default-width show-on-scroll">
			<div class="mcb-background-overlay"></div>
			<div class="section_wrapper mcb-section-inner mcb-section-inner-b3fc5e5e3 ">
				<div class="wrap mcb-wrap mcb-wrap-2fc33b290 mcb-header-wrap one tablet-one mobile-one clearfix"
					data-desktop-col="one" data-tablet-col="tablet-one" data-mobile-col="mobile-one">
					<div class="mcb-wrap-inner mcb-wrap-inner-2fc33b290">
						<div class="mcb-wrap-background-overlay"></div>
						<div class="column mcb-column mcb-item-d99d39c2f one tablet-one mobile-one column_header_logo">
							<div class="mcb-column-inner mcb-column-inner-d99d39c2f mcb-item-header_logo-inner"><a
									class="logo-wrapper" routerLink="/"><img
										src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore.svg"
										alt="furniturestore"></a></div>
						</div>
					</div>
				</div>
				<div class="wrap mcb-wrap mcb-wrap-bj66awxpc mcb-header-wrap one-third tablet-one-third mobile-one clearfix"
					data-desktop-col="one-third" data-tablet-col="tablet-one-third" data-mobile-col="mobile-one">
					<div class="mcb-wrap-inner mcb-wrap-inner-bj66awxpc">
						<div class="mcb-wrap-background-overlay"></div>
						<div
							class="column mcb-column mcb-item-xaps6eewm one tablet-one mobile-one column_header_burger mfn-item-inline  hide-desktop">
							<div class="mcb-column-inner mcb-column-inner-xaps6eewm mcb-item-header_burger-inner"><a
									data-nav="menu-2-categories-menu" routerLink="#"
									class="mfn-icon-box mfn-header-menu-burger mfn-icon-box-top mfn-icon-box-tablet-right mfn-icon-box-center mfn-header-menu-toggle mfn-icon-box-empty-desc">
									<div class="icon-wrapper"><i class="fa fa-bars" style="
    font-size: 20px; width: 25px;
"></i>
									</div>
								</a>
								<div
									class="mfn-header-tmpl-menu-sidebar mfn-header-tmpl-menu-sidebar-right mfn-close-icon-pos-default">
									<div class="mfn-header-tmpl-menu-sidebar-wrapper"><span
											class="mfn-close-icon mfn-header-menu-toggle"><span
												class="icon">&#10005;</span></span>
										<ul id="menu-2-categories-menu "
											class="mfn-header-menu mfn-menu-align-flex-start mfn-menu-tablet-align-flex-start mfn-menu-mobile-align-flex-start mfn-items-align-top mfn-items-align-left mfn-menu-icon-left mfn-menu-separator-off mfn-menu-submenu-on-click">
											<li id="menu-item-239"
												class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-239 mfn-menu-li">
												<a routerLink="/product-category/chairs/" class="mfn-menu-link"><span
														class="menu-item-helper mfn-menu-item-helper"></span><span
														class="menu-icon mfn-menu-item-icon"><img
															src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-category1.svg"
															alt=""></span><span
														class="label-wrapper mfn-menu-label-wrapper"><span
															class="menu-label">Chairs</span></span><span
														class="menu-sub mfn-menu-subicon"><i
															class="fas fa-arrow-down"></i></span></a>
											</li>
											<li id="menu-item-243"
												class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-243 mfn-menu-li">
												<a routerLink="/product-category/beds/" class="mfn-menu-link"><span
														class="menu-item-helper mfn-menu-item-helper"></span><span
														class="menu-icon mfn-menu-item-icon"><img
															src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-category2.svg"
															alt=""></span><span
														class="label-wrapper mfn-menu-label-wrapper"><span
															class="menu-label">Beds</span></span><span
														class="menu-sub mfn-menu-subicon"><i
															class="fas fa-arrow-down"></i></span></a>
											</li>
											<li id="menu-item-240"
												class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-240 mfn-menu-li">
												<a routerLink="/product-category/tables/" class="mfn-menu-link"><span
														class="menu-item-helper mfn-menu-item-helper"></span><span
														class="menu-icon mfn-menu-item-icon"><img
															src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-category3.svg"
															alt=""></span><span
														class="label-wrapper mfn-menu-label-wrapper"><span
															class="menu-label">Tables</span></span><span
														class="menu-sub mfn-menu-subicon"><i
															class="fas fa-arrow-down"></i></span></a>
											</li>
											<li id="menu-item-241"
												class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-241 mfn-menu-li">
												<a routerLink="/product-category/desks/" class="mfn-menu-link"><span
														class="menu-item-helper mfn-menu-item-helper"></span><span
														class="menu-icon mfn-menu-item-icon"><img
															src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-category4.svg"
															alt=""></span><span
														class="label-wrapper mfn-menu-label-wrapper"><span
															class="menu-label">Desks</span></span><span
														class="menu-sub mfn-menu-subicon"><i
															class="fas fa-arrow-down"></i></span></a>
											</li>
											<li id="menu-item-242"
												class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-242 mfn-menu-li">
												<a routerLink="/product-category/cabinets/" class="mfn-menu-link"><span
														class="menu-item-helper mfn-menu-item-helper"></span><span
														class="menu-icon mfn-menu-item-icon"><img
															src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-category5.svg"
															alt=""></span><span
														class="label-wrapper mfn-menu-label-wrapper"><span
															class="menu-label">Cabinets</span></span><span
														class="menu-sub mfn-menu-subicon"><i
															class="fas fa-arrow-down"></i></span></a>
											</li>
											<li id="menu-item-238"
												class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-238 mfn-menu-li">
												<a routerLink="/product-category/lighting/" class="mfn-menu-link"><span
														class="menu-item-helper mfn-menu-item-helper"></span><span
														class="menu-icon mfn-menu-item-icon"><img
															src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-category6.svg"
															alt=""></span><span
														class="label-wrapper mfn-menu-label-wrapper"><span
															class="menu-label">Lighting</span></span><span
														class="menu-sub mfn-menu-subicon"><i
															class="fas fa-arrow-down"></i></span></a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<div
							class="column mcb-column mcb-item-hhir7p7g5 one tablet-one mobile-one column_header_icon mfn-item-inline">
							<div class="mcb-column-inner mcb-column-inner-hhir7p7g5 mcb-item-header_icon-inner">
								<div class="search_wrapper">
									<form method="get" id="searchform"
										action="https://themes.muffingroup.com/be/furniturestore/">


										<svg class="icon_search" width="26" viewBox="0 0 26 26"
											aria-label="search icon">
											<defs>
												<style>
													.path {
														fill: none;
														stroke: #000;
														stroke-miterlimit: 10;
														stroke-width: 1.5px;
													}
												</style>
											</defs>
											<circle class="path" cx="11.35" cy="11.35" r="6"></circle>
											<line class="path" x1="15.59" y1="15.59" x2="20.65" y2="20.65"></line>
										</svg>
										<span class="mfn-close-icon icon_close" tabindex="0"><span
												class="icon">✕</span></span>


										<input type="text" class="field" name="s" autocomplete="off"
											placeholder="Enter your search" />
										<input type="submit" class="display-none" value="" />

									</form>

									<div class="mfn-live-search-box" style="display:none">

										<ul class="mfn-live-search-list">
											<li class="mfn-live-search-list-categories">
												<ul></ul>
											</li>
											<li class="mfn-live-search-list-shop">
												<ul></ul>
											</li>
											<li class="mfn-live-search-list-blog">
												<ul></ul>
											</li>
											<li class="mfn-live-search-list-pages">
												<ul></ul>
											</li>
											<li class="mfn-live-search-list-portfolio">
												<ul></ul>
											</li>
										</ul>

										<span class="mfn-live-search-noresults">No results</span>

										<a class="button button_theme hidden">See all results</a>

									</div>
								</div><a routerLink="#"
									class="mfn-icon-box mfn-header-icon-box mfn-icon-box-top mfn-icon-box-center mfn-header-search-link mfn-search-button mfn-searchbar-toggle mfn-icon-box-empty-desc">
									<div class="icon-wrapper"><i class="fas fa-search" style="z-index: -2;"></i></div>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="section mcb-section mfn-default-section mcb-section-f12298de5  mcb-header-section  hide-mobile close-button-left default-width show-on-scroll">
			<div class="mcb-background-overlay"></div>
			<div class="section_wrapper mcb-section-inner mcb-section-inner-f12298de5">
				<div class="wrap mcb-wrap mcb-wrap-7235b1f2d mcb-header-wrap one-third tablet-one-third mobile-one clearfix"
					data-desktop-col="" data-tablet-col="" data-mobile-col="mobile-one">
					<div class="mcb-wrap-inner mcb-wrap-inner-7235b1f2d">
						<div class="mcb-wrap-background-overlay"></div>
						<div class="column mcb-column mcb-item-66f23b1a1 one tablet-one mobile-one column_header_logo">
							<div class="mcb-column-inner mcb-column-inner-66f23b1a1 mcb-item-header_logo-inner">
								<a routerLink="/" class="logo-wrapper"><img
										src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore.svg"
										alt="furniturestore"></a>
							</div>
						</div>
					</div>
				</div>
				<div class="wrap mcb-wrap mcb-wrap-d13835cea mcb-header-wrap one-third tablet-one-third mobile-one clearfix"
					data-desktop-col="one-third" data-tablet-col="tablet-one-third" data-mobile-col="mobile-one">
					<div class="mcb-wrap-inner mcb-wrap-inner-d13835cea">
						<div class="mcb-wrap-background-overlay"></div>
						<div
							class="column mcb-column mcb-item-2ce86a16f one tablet-one mobile-one column_header_search">
							<!-- <div class="mcb-column-inner mcb-column-inner-2ce86a16f mcb-item-header_search-inner">
								<div class="search_wrapper">
									<form method="get" id="searchform"
										action="">


										<span class="icon_search"><i class="fas fa-search"></i></span>
										<span class="mfn-close-icon icon_close" tabindex="0"><span
												class="icon">✕</span></span>


										<input type="text" class="field" name="s" autocomplete="off"
											placeholder="What are you looking for?" />
										<input type="submit" class="display-none" value="" />

									</form>

									<div class="mfn-live-search-box" style="display:none">

										<ul class="mfn-live-search-list">
											<li class="mfn-live-search-list-categories">
												<ul></ul>
											</li>
											<li class="mfn-live-search-list-shop">
												<ul></ul>
											</li>
											<li class="mfn-live-search-list-blog">
												<ul></ul>
											</li>
											<li class="mfn-live-search-list-pages">
												<ul></ul>
											</li>
											<li class="mfn-live-search-list-portfolio">
												<ul></ul>
											</li>
										</ul>

										<span class="mfn-live-search-noresults">No results</span>

										<a class="button button_theme hidden">See all results</a>

									</div>
								</div>
							</div> -->

							<div class="mcb-column-inner mcb-column-inner-2ce86a16f mcb-item-header_search-inner">
								<div class="search_wrapper">
									<form method="get" id="searchform" (submit)="$event.preventDefault()">
										<span class="icon_search"><i class="fas fa-search"></i></span>
										<span class="mfn-close-icon icon_close" tabindex="0"><span
												class="icon">✕</span></span>

										<input type="text" class="field" name="s" autocomplete="off"
											placeholder="What are you looking for?" [value]="searchQuery"
											(input)="onSearchChange($event.target.value)" />
									</form>

									<div class="mfn-live-search-box" *ngIf="searchResults?.length > 0"
										style="display:block">
										<ul class="mfn-live-search-list">
											<li class="mfn-live-search-list-shop">
												<ul *ngIf="searchResults.length > 0" class="search-results">
													<li *ngFor="let product of searchResults">
														<a [routerLink]="['/product', product.id]">{{ product.title
															}}</a>
													</li>
												</ul>
											</li>
										</ul>
										<a class="button button_theme" [routerLink]="['/search']"
											[queryParams]="{ q: searchQuery  }">
											See all results
										</a>
									</div>

									<!-- <span class="mfn-live-search-noresults" *ngIf="searchResults?.length === 0 && searchQuery.length > 1">
      No results
    </span> -->
								</div>
							</div>


						</div>
					</div>
				</div>
				<div class="wrap mcb-wrap mcb-wrap-aba8ccfee mcb-header-wrap one-third tablet-one-third mobile-one clearfix"
					data-desktop-col="" data-tablet-col="" data-mobile-col="mobile-one">
					<div class="mcb-wrap-inner mcb-wrap-inner-aba8ccfee">
						<div class="mcb-wrap-background-overlay"></div>
						<div
							class="column mcb-column mcb-item-df4633b35 one tablet-one mobile-one column_header_icon mfn-item-inline">

							<div
								class="mcb-column-inner mcb-column-inner-df4633b35 mcb-item-header_icon-inner dropdown">
								<a data-toggle="dropdown" aria-expanded="true" style="cursor: pointer;"
									class="dropdown-toggle mfn-icon-box mfn-header-icon-box mfn-icon-box-left mfn-icon-box-center mfn-header-cart-link toggle-mfn-cart">
									<div class="icon-wrapper "><i class="fas fa-shopping-cart"></i><span
											class="header-cart-count">{{cartData.data[0].numInCart !== 0 ?
											cartData.data.length : 0}}</span></div>
									<div class="desc-wrapper ">
										<p class="header-cart-total">{{cartData.data[0].numInCart !== 0 ?
											cartData.data.length : 0}} Item(s)</p>
										<!-- <small>TOTAL : {{cartTotal | currency:'INR'}}</small>  -->

									</div>
								</a>
								<div class="cart-dropdown">
									<div class="cart-list" *ngIf="cartData.data[0].numInCart !== 0">
										<div class="product-widget" *ngFor="let c of cartData.data; let i=index">
											<div class="product-img">
												<img [src]="imageBaseUrl + c.product?.image" alt="" width="20px">
											</div>
											<div class="product-body">
												<h3 class="product-name"><a routerLink="#">{{c.product?.name}}</a></h3>
												<h4 class="product-price"><span class="qty">{{c.numInCart}} x
													</span>{{c.product?.price |
													currency:'INR'}}</h4>
											</div>
											<button class="delete" (click)="cartService.DeleteProductFromCart(i)"><i
													class="fas fa-times"></i></button>
										</div>


									</div>
									<div class="cart-summary">
										<small>{{cartData.data[0].numInCart !== 0 ? cartData.data.length : 0}} Item(s)
											selected</small>
										<h5>TOTAL : {{cartTotal | currency:'INR'}}</h5>
									</div>
									<div class="cart-btns">
										<a routerLink="/cart">View Cart</a>
										<a routerLink="/checkout">Checkout <i class="fa fa-arrow-circle-right"></i></a>
									</div>
								</div>
							</div>
						</div>

						<!-- <div class="dropdown">
							<a class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true" style="cursor: pointer;">
								<i class="fa fa-shopping-cart"></i>
								<span>Your Cart</span>
								<div class="qty">{{cartData.data[0].numInCart !== 0 ? cartData.data.length : 0}}</div>
							</a>
							<div class="cart-dropdown">
								<div class="cart-list" *ngIf="cartData.data[0].numInCart !== 0">
									<div class="product-widget" *ngFor="let c of cartData.data; let i=index">
										<div class="product-img">
											<img src="{{c.product?.image}}" alt="" width="20px">
										</div>
										<div class="product-body">
											<h3 class="product-name"><a routerLink="#">{{c.product?.name}}</a></h3>
											<h4 class="product-price"><span class="qty">{{c.numInCart}} x </span>{{c.product?.price |
												currency:'EUR'}}</h4>
										</div>
										<button class="delete" (click)="cartService.DeleteProductFromCart(i)"><i
												class="fa fa-close"></i></button>
									</div>
						
						
								</div>
								<div class="cart-summary">
									<small>{{cartData.data[0].numInCart !== 0 ? cartData.data.length : 0}} Item(s) selected</small>
									<h5>TOTAL : {{cartTotal | currency:'EUR'}}</h5>
								</div>
								<div class="cart-btns">
									<a routerLink="/cart">View Cart</a>
									<a routerLink="/checkout">Checkout <i class="fa fa-arrow-circle-right"></i></a>
								</div>
							</div>
						</div> -->
						<!-- <div
							class="column mcb-column mcb-item-e01e28521 one tablet-one mobile-one column_header_icon mfn-item-inline">
							<div class="mcb-column-inner mcb-column-inner-e01e28521 mcb-item-header_icon-inner"><a
									routerLink="/wishlist/"
									class="mfn-icon-box mfn-header-icon-box mfn-icon-box-top mfn-icon-box-center mfn-header-wishlist-link mfn-icon-box-empty-desc">
									<div class="icon-wrapper"><img class="scale-with-grid"
											src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-wishlist.svg"
											alt=""><span class="header-wishlist-count">1</span></div>
								</a></div>
						</div> -->
						<div
							class="column mcb-column mcb-item-38be34796 one tablet-one mobile-one column_header_icon mfn-item-inline">
							<div class="mcb-column-inner mcb-column-inner-38be34796 mcb-item-header_icon-inner">
								<ng-template #guestLinks>
									<a routerLink="#"
										class="mfn-icon-box mfn-header-icon-box mfn-icon-box-top mfn-icon-box-center mfn-header-account-link toggle-login-modal is-boxed mfn-icon-box-empty-desc"
										onclick="document.querySelector('.mfn-header-modal-login').classList.toggle('active'); return false;">
										<div class="icon-wrapper"><i class="fas fa-user"></i></div>
									</a>
								</ng-template>
								<ng-container *ngIf="isLoggedIn; else guestLinks">
									<!-- User Dropdown Trigger -->
									<div class="user-dropdown dropdown-toggle" [class.open]="isUserDropdownOpen"
										(click)="toggleUserDropdown()">
										<i class="fas fa-user-circle"></i>
										<span *ngIf="isLoggedIn"> {{ username?.substring(0, 5) }}..</span>


										<!-- Dropdown content -->
										<div class="user-dropdown-menu" *ngIf="isUserDropdownOpen">
											<ng-container *ngIf="isLoggedIn; else guestMenu">
												<p>Hi, {{ username?.substring(0, 7) }}</p>
												<span> My Account</span>
												<button class="dropdown-logout-btn" (click)="logout()">Logout</button>
											</ng-container>

											<ng-template #guestMenu>
												<a routerLink="javascript:void(0)" (click)="openLoginModal()">Login</a>
												<a routerLink="javascript:void(0)"
													(click)="openRegisterModal()">Register</a>
											</ng-template>
										</div>
									</div>

								</ng-container>

								<div class="mfn-header-login woocommerce mfn-header-modal-login">
									<span class="mfn-close-icon toggle-login-modal close-login-modal"
										onclick="document.querySelector('.mfn-header-modal-login').classList.toggle('active'); return false;"><span
											class="icon">&#10005;</span></span>
									<h4>Login</h4>
									<form class="woocommerce-form woocommerce-form-login login" [formGroup]="loginForm"
										(ngSubmit)="onLogin()">



										<p class="input-icon-wrapper">
											<!-- <label for="username">Email&nbsp;<span
													class="required">*</span></label> -->
											<i class="fas fa-envelope icon"></i>
											<input type="email" class="input-text" placeholder="Email *"
												formControlName="email" />

										</p>
										<p class="input-icon-wrapper input-top">
											<!-- <label for="password">Password&nbsp;<span class="required">*</span></label> -->
											<i class="fas fa-lock icon"></i>
											<input class="input-text woocommerce-Input" type="password"
												formControlName="password" autocomplete="current-password"
												placeholder="Password *" />

										</p>
										<div class="clear"></div>


										<p class="form-row">
											<label
												class="woocommerce-form__label woocommerce-form__label-for-checkbox woocommerce-form-login__rememberme">
												<input class="woocommerce-form__input woocommerce-form__input-checkbox"
													name="rememberme" type="checkbox" id="rememberme" value="forever" />
												<span> Remember me</span>
											</label>
											<input type="hidden" id="woocommerce-login-nonce"
												name="woocommerce-login-nonce" value="f0fce528e7" /><input type="hidden"
												name="_wp_http_referer" value="/be/furniturestore/" />
											<input type="hidden" name="redirect" value="" />
											<button type="submit"
												class="woocommerce-button button woocommerce-form-login__submit wp-element-button"
												name="login" value="Login">Login</button>
										</p>
										<div *ngIf="loginError" class="error">{{ loginError }}</div>
										<div *ngIf="loginSuccess" class="success">{{ loginSuccess }}</div>
										<p class="register_link text-center">
											Don't have an account?
											<a routerLink="javascript:void(0)" (click)="switchToRegister()">Register</a>
										</p>
										<p class="lost_password">
											<a routerLink="/my-account/lost-password/">Lost
												your password?</a>
										</p>

										<div class="clear"></div>


									</form>
								</div>
								<!-- REGISTER MODAL -->
								<div class="mfn-header-login woocommerce mfn-header-modal-register">
									<span class="mfn-close-icon toggle-register-modal close-register-modal">
										<span class="icon" (click)="closeRegisterModal()">&#10005;</span>
									</span>
									<h4>Register</h4>
									<form class="woocommerce-form woocommerce-form-register register"
										[formGroup]="registerForm" (ngSubmit)="onRegister()">
										<p class="input-icon-wrapper">
											<!-- <label for="username">Username&nbsp;<span
													class="required">*</span></label> -->
											<i class="fas fa-user icon"></i>
											<input type="text" class="input-text" placeholder="Username *"
												formControlName="username" />
										</p>
										<p class="input-icon-wrapper input-top">
											<!-- <label for="username">Email&nbsp;<span
													class="required">*</span></label> -->
											<i class="fas fa-envelope icon"></i>
											<input type="text" class="input-text" placeholder="Email *"
												formControlName="email" />
										</p>
										<p class="input-icon-wrapper input-top">
											<!-- <label for="password">Password&nbsp;<span class="required">*</span></label> -->
											<i class="fas fa-lock icon"></i>
											<input class="input-text woocommerce-Input" type="password"
												placeholder="Password *" formControlName="password" />

										</p>
										<p class="input-icon-wrapper input-top">
											<!-- <label for="password">Conform Password&nbsp;<span class="required">*</span></label> -->
											<i class="fas fa-lock icon"></i>
											<input class="input-text woocommerce-Input" placeholder="Conform Password *"
												type="password" name="password" />

										</p>
										<div class="clear"></div>



										<p class="form-row">
											<button type="submit"
												class="woocommerce-button button woocommerce-form-login__submit wp-element-button">Register</button>
										</p>

										<div *ngIf="registerError" class="error">{{ registerError }}</div>
										<div *ngIf="registerSuccess" class="success">{{ registerSuccess }}</div>

										<p class="text-center">
											Already have an account?
											<a routerLink="javascript:void(0)" (click)="switchToLogin()">Login</a>
										</p>
									</form>
								</div>

							</div>
						</div>
						<div
							class="column mcb-column mcb-item-3c55br08 one tablet-one mobile-one column_header_burger mfn-item-inline  hide-desktop">
							<div class="mcb-column-inner mcb-column-inner-3c55br08 mcb-item-header_burger-inner"><a
									data-nav="menu-2-categories-menu" routerLink="#"
									class="mfn-icon-box mfn-header-menu-burger mfn-icon-box-top mfn-icon-box-tablet-right mfn-icon-box-center mfn-header-menu-toggle mfn-icon-box-empty-desc">
									<div class="icon-wrapper"><i class="icon-menu-fine" aria-hidden="true"></i>
									</div>
								</a>
								<div
									class="mfn-header-tmpl-menu-sidebar mfn-header-tmpl-menu-sidebar-right mfn-close-icon-pos-default">
									<div class="mfn-header-tmpl-menu-sidebar-wrapper"><span
											class="mfn-close-icon mfn-header-menu-toggle"><span
												class="icon">&#10005;</span></span>
										<ul id="menu-2-categories-menu-1"
											class="mfn-header-menu mfn-menu-align-flex-start mfn-menu-tablet-align-flex-start mfn-menu-mobile-align-flex-start mfn-items-align-top mfn-items-align-left mfn-menu-icon-left mfn-menu-separator-off mfn-menu-submenu-on-click">
											<li
												class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-239 mfn-menu-li">
												<a routerLink="/product-category/chairs/" class="mfn-menu-link"><span
														class="menu-item-helper mfn-menu-item-helper"></span><span
														class="menu-icon mfn-menu-item-icon"><img
															src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-category1.svg"
															alt=""></span><span
														class="label-wrapper mfn-menu-label-wrapper"><span
															class="menu-label">Chairs</span></span><span
														class="menu-sub mfn-menu-subicon"><i
															class="fas fa-arrow-down"></i></span></a>
											</li>
											<li
												class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-243 mfn-menu-li">
												<a routerLink="/product-category/beds/" class="mfn-menu-link"><span
														class="menu-item-helper mfn-menu-item-helper"></span><span
														class="menu-icon mfn-menu-item-icon"><img
															src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-category2.svg"
															alt=""></span><span
														class="label-wrapper mfn-menu-label-wrapper"><span
															class="menu-label">Beds</span></span><span
														class="menu-sub mfn-menu-subicon"><i
															class="fas fa-arrow-down"></i></span></a>
											</li>
											<li
												class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-240 mfn-menu-li">
												<a routerLink="/product-category/tables/" class="mfn-menu-link"><span
														class="menu-item-helper mfn-menu-item-helper"></span><span
														class="menu-icon mfn-menu-item-icon"><img
															src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-category3.svg"
															alt=""></span><span
														class="label-wrapper mfn-menu-label-wrapper"><span
															class="menu-label">Tables</span></span><span
														class="menu-sub mfn-menu-subicon"><i
															class="fas fa-arrow-down"></i></span></a>
											</li>
											<li
												class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-241 mfn-menu-li">
												<a routerLink="/product-category/desks/" class="mfn-menu-link"><span
														class="menu-item-helper mfn-menu-item-helper"></span><span
														class="menu-icon mfn-menu-item-icon"><img
															src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-category4.svg"
															alt=""></span><span
														class="label-wrapper mfn-menu-label-wrapper"><span
															class="menu-label">Desks</span></span><span
														class="menu-sub mfn-menu-subicon"><i
															class="fas fa-arrow-down"></i></span></a>
											</li>
											<li
												class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-242 mfn-menu-li">
												<a routerLink="/product-category/cabinets/" class="mfn-menu-link"><span
														class="menu-item-helper mfn-menu-item-helper"></span><span
														class="menu-icon mfn-menu-item-icon"><img
															src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-category5.svg"
															alt=""></span><span
														class="label-wrapper mfn-menu-label-wrapper"><span
															class="menu-label">Cabinets</span></span><span
														class="menu-sub mfn-menu-subicon"><i
															class="fas fa-arrow-down"></i></span></a>
											</li>
											<li
												class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-238 mfn-menu-li">
												<a routerLink="/product-category/lighting/" class="mfn-menu-link"><span
														class="menu-item-helper mfn-menu-item-helper"></span><span
														class="menu-icon mfn-menu-item-icon"><img
															src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-category6.svg"
															alt=""></span><span
														class="label-wrapper mfn-menu-label-wrapper"><span
															class="menu-label">Lighting</span></span><span
														class="menu-sub mfn-menu-subicon"><i
															class="fas fa-arrow-down"></i></span></a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>


				<!-- cart toggle dropdown-->
				<div class="mfn-cart-holder woocommerce" tabindex="0" aria-expanded="true" aria-label="shop cart"
					role="navigation">
					<div class="mfn-ch-row mfn-ch-header">
						<a class="toggle-mfn-cart close-mfn-cart mfn-close-icon" tabindex="0"><span
								class="icon">✕</span></a>
						<h3>
							<svg width="26" viewBox="0 0 26 26" aria-label="cart icon">
								<defs>
									<style>
										.path {
											fill: none;
											stroke: #333;
											stroke-miterlimit: 10;
											stroke-width: 1.5px;
										}
									</style>
								</defs>
								<polygon class="path" points="20.4 20.4 5.6 20.4 6.83 10.53 19.17 10.53 20.4 20.4">
								</polygon>
								<path class="path" d="M9.3,10.53V9.3a3.7,3.7,0,1,1,7.4,0v1.23"></path>
							</svg>Cart
						</h3>
					</div>
					<div class="mfn-ch-row mfn-ch-content-wrapper">
						<div class="mfn-ch-row mfn-ch-content">
							<div class="cart-empty">
								<p class="cart-empty-icon">
									<svg width="26" viewBox="0 0 26 26" aria-hidden="true">
										<defs>
											<style>
												.path {
													fill: none;
													stroke: #333;
													stroke-miterlimit: 10;
													stroke-width: 1.5px;
												}
											</style>
										</defs>
										<polygon class="path"
											points="20.4 20.4 5.6 20.4 6.83 10.53 19.17 10.53 20.4 20.4"></polygon>
										<path class="path" d="M9.3,10.53V9.3a3.7,3.7,0,1,1,7.4,0v1.23"></path>
									</svg>
								</p>
								<p>Your cart is currently empty.</p>
							</div>
						</div>
					</div>
					<div class="mfn-ch-row mfn-ch-footer">

						<div class="mfn-ch-footer-totals">
							<div class="mfn-chft-row mfn-chft-subtotal">Subtotal: <span
									class="woocommerce-Price-amount amount"><bdi><span
											class="woocommerce-Price-currencySymbol">$</span>0.00</bdi></span></div>
							<div class="mfn-chft-row mfn-chft-total">Total: <strong><span
										class="woocommerce-Price-amount amount"><bdi><span
												class="woocommerce-Price-currencySymbol">$</span>0.00</bdi></span></strong>
							</div>
						</div>

						<div class="mfn-ch-footer-buttons">
							<a routerLink="/checkout/" class="button button_full_width button_theme">Proceed to
								checkout</a>
							<a routerLink="/cart/" tabindex="0">View cart</a>
						</div>

					</div>
				</div>
				<!-- end cart toggle --->

			</div>
		</div>
		<div [class.sticky-header]="isSticky" id="main-header"
			class="section mcb-section mfn-default-section mcb-section-f3dc65e25 mcb-header-section  hide-tablet hide-mobile close-button-left default-width show-on-scroll">
			<div class="mcb-background-overlay"></div>
			<div class="section_wrapper mcb-section-inner mcb-section-inner-f3dc65e25">
				<div class="wrap mcb-wrap mcb-wrap-946a0f099 mcb-header-wrap one tablet-one mobile-one clearfix"
					data-desktop-col="one" data-tablet-col="tablet-one" data-mobile-col="mobile-one">
					<div class="mcb-wrap-inner mcb-wrap-inner-946a0f099">
						<div class="mcb-wrap-background-overlay"></div>
						<div
							class="column mcb-column mcb-item-80822a560 one tablet-one mobile-one column_header_menu mfn-item-inline">
							<div class="mcb-column-inner mcb-column-inner-80822a560 mcb-item-header_menu-inner">
								<ul id="menu-2-categories-menu-2"
									class="mfn-header-menu mfn-header-mainmenu mfn-menu-align-flex-start mfn-menu-tablet-align-flex-start mfn-menu-mobile-align-flex-start mfn-menu-icon-top mfn-menu-separator-on mfn-menu-submenu-on-hover mfn-menu-submenu-show-fade-up">

									<li [id]="'menu-item-' + (238 + i)"
										[class]="'menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-' + (238 + i) + ' mfn-menu-item-has-megamenu mfn-menu-li'"
										*ngFor="let menu of menuList  let i = index">
										<a routerLink="/product-category/{{getSlug(menu.title)}}"
											class="mfn-menu-link"><span
												class="menu-item-helper mfn-menu-item-helper"></span>
												<span class="menu-icon mfn-menu-item-icon">
													<img [src]="otherimageBaseUrl + menu.icon" alt=""></span>
													<span
												class="label-wrapper mfn-menu-label-wrapper"><span
													class="menu-label">{{menu.title}}</span></span><span
												class="menu-sub mfn-menu-subicon"><i
													class="fas fa-arrow-down"></i></span></a>
										<div [id]="'mfn-megamenu-' + (165 + i)" [ngClass]="{
									      'mfn-menu-item-megamenu': true,
									      'mfn-megamenu-custom-width': true,
									      'mfn-megamenu-pos-left': i < 4,
									      'mfn-megamenu-pos-right': i >= 4
									    }" style="width: 620px">
											<div class="mfn-builder-content mfn-megamenu-tmpl-builder container">
												<div
													class="section mcb-section mfn-default-section mcb-section-1cf4b67c8 default-width">
													<div class="mcb-background-overlay"></div>
													<div
														class="section_wrapper mcb-section-inner mcb-section-inner-1cf4b67c8">
														<div class="wrap mcb-wrap mcb-wrap-a9741420e two-fifth tablet-two-fifth mobile-one clearfix"
															data-desktop-col="two-fifth"
															data-tablet-col="tablet-two-fifth"
															data-mobile-col="mobile-one">
															<div class="mcb-wrap-inner mcb-wrap-inner-a9741420e">
																<div class="mcb-wrap-background-overlay"></div>
																<div
																	class="column mcb-column mcb-item-4a7a04c58 one tablet-one mobile-one column_megamenu_menu">
																	<div
																		class="mcb-column-inner mcb-column-inner-08160e4dc  mcb-item-megamenu_menu-inner">
																		<ul id="mfn-megamenu-ul-103"
																			class="mfn-megamenu-menu mfn-mm-menu-vertical mfn-mm-submenu-visible mfn-mm-menu-icon-left">
																			<li id="megamenu-menu-item-226"
																				class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-226"
																				*ngFor="let sub of menu.submenus">
																				<a
																					routerLink="/product-category/{{getSlug(menu.title)}}/{{getSlug(sub.title)}}/"><span
																						class="label-wrapper"><span
																							class="menu-label">{{
																							sub.title
																							}}</span></span><span
																						class="menu-sub"><i
																							class="fas fa-arrow-down"></i></span><span
																						class="decoration-icon"><i
																							class="fas fa-chevron-right"></i></span></a>
																			</li>
																			<!-- <li id="megamenu-menu-item-227"
																				class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-227">
																				<a
																					routerLink="/product-category/chairs/bar-stools/"><span
																						class="label-wrapper"><span
																							class="menu-label">Bar
																							stools</span></span><span
																						class="menu-sub"><i
																							class="fas fa-arrow-down"></i></span><span
																						class="decoration-icon"><i
																							class="fas fa-chevron-right"></i></span></a>
																			</li>
																			<li id="megamenu-menu-item-228"
																				class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-228">
																				<a
																					routerLink="/product-category/chairs/chair-pads/"><span
																						class="label-wrapper"><span
																							class="menu-label">Chair
																							pads</span></span><span
																						class="menu-sub"><i
																							class="fas fa-arrow-down"></i></span><span
																						class="decoration-icon"><i
																							class="fas fa-chevron-right"></i></span></a>
																			</li>
																			<li id="megamenu-menu-item-229"
																				class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-229">
																				<a
																					routerLink="/product-category/chairs/chaise-lounges/"><span
																						class="label-wrapper"><span
																							class="menu-label">Chaise
																							lounges</span></span><span
																						class="menu-sub"><i
																							class="fas fa-arrow-down"></i></span><span
																						class="decoration-icon"><i
																							class="fas fa-chevron-right"></i></span></a>
																			</li>
																			<li id="megamenu-menu-item-230"
																				class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-230">
																				<a
																					routerLink="/product-category/chairs/desk-chairs/"><span
																						class="label-wrapper"><span
																							class="menu-label">Desk
																							Chairs</span></span><span
																						class="menu-sub"><i
																							class="fas fa-arrow-down"></i></span><span
																						class="decoration-icon"><i
																							class="fas fa-chevron-right"></i></span></a>
																			</li>
																			<li id="megamenu-menu-item-231"
																				class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-231">
																				<a
																					routerLink="/product-category/chairs/dining-chairs/"><span
																						class="label-wrapper"><span
																							class="menu-label">Dining
																							Chairs</span></span><span
																						class="menu-sub"><i
																							class="fas fa-arrow-down"></i></span><span
																						class="decoration-icon"><i
																							class="fas fa-chevron-right"></i></span></a>
																			</li> -->
																		</ul>
																	</div>
																</div>
															</div>
														</div>
														<div class="wrap mcb-wrap mcb-wrap-2acfce73c three-fifth tablet-three-fifth mobile-one clearfix "
															data-desktop-col="three-fifth"
															data-tablet-col="tablet-three-fifth"
															data-mobile-col="mobile-one">
															<div
																class="mcb-wrap-inner mcb-wrap-inner-2acfce73c recommendation-card">
																<div class="mcb-wrap-background-overlay"></div>
																<div
																	class="column mcb-column mcb-item-9a6e579ed one tablet-one mobile-one column_heading">
																	<div
																		class="mcb-column-inner mcb-column-inner-9a6e579ed mcb-item-heading-inner">
																		<h6 class="title">WE RECOMMEND</h6>
																	</div>
																</div>
																<div
																	class="column mcb-column mcb-item-00d9f36ec one tablet-one mobile-one column_column">
																	<div
																		class="mcb-column-inner mcb-column-inner-00d9f36ec mcb-item-column-inner">
																		<div
																			class="column_attr mfn-inline-editor clearfix title">
																			{{menu.desc_title}}</div>
																	</div>
																</div>
																<div
																	class="column mcb-column mcb-item-c653fff55 one tablet-one mobile-one column_column">
																	<div
																		class="mcb-column-inner mcb-column-inner-c653fff55 mcb-item-column-inner">
																		<div
																			class="column_attr mfn-inline-editor clearfix description">
																			{{ menu.description}}</div>
																	</div>
																</div>
																<!-- <div class="column mcb-column mcb-item-1ed2cd39a one tablet-one mobile-one column_column"
																	>
																	<div
																		class="mcb-column-inner mcb-column-inner-1ed2cd39a mcb-item-column-inner">
																		<div class="column_attr mfn-inline-editor clearfix"
																			>$1550.00</div>
																	</div>
																</div> -->
																<div
																	class="column mcb-column mcb-item-hlnhan32g one tablet-one mobile-one column_image mfn-column-absolute">
																	<div
																		class="mcb-column-inner mcb-column-inner-hlnhan32g mcb-item-image-inner">
																		<div
																			class="image_frame element_classes image_item no_link scale-with-grid alignnone no_border price">
																			<div class="image_wrapper"><img
																					class="scale-with-grid"
																					[src]="otherimageBaseUrl + menu.image"
																					alt="furniturestore-megamenu-pic1"
																					title="" width="600" height="600" />
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</li>


								</ul>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
		<div
			class="section mcb-section mfn-header-sticky-section mcb-section-0cda2571c mcb-header-section close-button-left default-width show-on-scroll">
			<div class="mcb-background-overlay"></div>
			<div class="section_wrapper mcb-section-inner mcb-section-inner-0cda2571c">
				<div class="wrap mcb-wrap mcb-wrap-39818df64 mcb-header-wrap one tablet-one mobile-one clearfix"
					data-desktop-col="one" data-tablet-col="tablet-one" data-mobile-col="mobile-one">
					<div class="mcb-wrap-inner mcb-wrap-inner-39818df64">
						<div class="mcb-wrap-background-overlay"></div>
						<div
							class="column mcb-column mcb-item-f8010517c one tablet-one mobile-one column_header_menu mfn-item-inline">
							<div class="mcb-column-inner mcb-column-inner-f8010517c mcb-item-header_menu-inner">
								<ul id="menu-2-categories-menu-3"
									class="mfn-header-menu mfn-header-mainmenu mfn-menu-align-flex-start mfn-menu-tablet-align-flex-start mfn-menu-mobile-align-flex-start mfn-menu-icon-top mfn-menu-separator-on mfn-menu-submenu-on-hover">
									<li
										class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-239 mfn-menu-item-has-megamenu mfn-menu-li">
										<a routerLink="/product-category/chairs/" class="mfn-menu-link"><span
												class="menu-item-helper mfn-menu-item-helper"></span><span
												class="menu-icon mfn-menu-item-icon"><img
													src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-category1.svg"
													alt=""></span><span
												class="label-wrapper mfn-menu-label-wrapper"><span
													class="menu-label">Chairs</span></span><span
												class="menu-sub mfn-menu-subicon"><i
													class="fas fa-arrow-down"></i></span></a>
										<div id="mfn-megamenu-165"
											class="mfn-menu-item-megamenu mfn-megamenu-custom-width mfn-megamenu-pos-left"
											style="width: 720px">
											<div class="mfn-builder-content mfn-megamenu-tmpl-builder container">
												<div
													class="section mcb-section mfn-default-section mcb-section-1cf4b67c8 default-width">
													<div class="mcb-background-overlay"></div>
													<div
														class="section_wrapper mcb-section-inner mcb-section-inner-1cf4b67c8">
														<div class="wrap mcb-wrap mcb-wrap-a9741420e two-fifth tablet-two-fifth mobile-one clearfix"
															data-desktop-col="two-fifth"
															data-tablet-col="tablet-two-fifth"
															data-mobile-col="mobile-one">
															<div class="mcb-wrap-inner mcb-wrap-inner-a9741420e">
																<div class="mcb-wrap-background-overlay"></div>
																<div
																	class="column mcb-column mcb-item-4a7a04c58 one tablet-one mobile-one column_megamenu_menu">
																	<div
																		class="mcb-column-inner mcb-column-inner-4a7a04c58 mcb-item-megamenu_menu-inner">
																		<ul id="mfn-megamenu-ul-103"
																			class="mfn-megamenu-menu mfn-mm-menu-vertical mfn-mm-submenu-visible mfn-mm-menu-icon-left">
																			<li
																				class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-226">
																				<a
																					routerLink="/product-category/chairs/armchairs/"><span
																						class="label-wrapper"><span
																							class="menu-label">Armchairs</span></span><span
																						class="menu-sub"><i
																							class="fas fa-arrow-down"></i></span><span
																						class="decoration-icon"><i
																							class="fas fa-chevron-right"></i></span></a>
																			</li>
																			<li
																				class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-227">
																				<a
																					routerLink="/product-category/chairs/bar-stools/"><span
																						class="label-wrapper"><span
																							class="menu-label">Bar
																							stools</span></span><span
																						class="menu-sub"><i
																							class="fas fa-arrow-down"></i></span><span
																						class="decoration-icon"><i
																							class="fas fa-chevron-right"></i></span></a>
																			</li>
																			<li
																				class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-228">
																				<a
																					routerLink="/product-category/chairs/chair-pads/"><span
																						class="label-wrapper"><span
																							class="menu-label">Chair
																							pads</span></span><span
																						class="menu-sub"><i
																							class="fas fa-arrow-down"></i></span><span
																						class="decoration-icon"><i
																							class="fas fa-chevron-right"></i></span></a>
																			</li>
																			<li
																				class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-229">
																				<a
																					routerLink="/product-category/chairs/chaise-lounges/"><span
																						class="label-wrapper"><span
																							class="menu-label">Chaise
																							lounges</span></span><span
																						class="menu-sub"><i
																							class="fas fa-arrow-down"></i></span><span
																						class="decoration-icon"><i
																							class="fas fa-chevron-right"></i></span></a>
																			</li>
																			<li
																				class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-230">
																				<a
																					routerLink="/product-category/chairs/desk-chairs/"><span
																						class="label-wrapper"><span
																							class="menu-label">Desk
																							Chairs</span></span><span
																						class="menu-sub"><i
																							class="fas fa-arrow-down"></i></span><span
																						class="decoration-icon"><i
																							class="fas fa-chevron-right"></i></span></a>
																			</li>
																			<li
																				class="menu-item menu-item-type-taxonomy menu-item-object-product_cat menu-item-231">
																				<a
																					routerLink="/product-category/chairs/dining-chairs/"><span
																						class="label-wrapper"><span
																							class="menu-label">Dining
																							Chairs</span></span><span
																						class="menu-sub"><i
																							class="fas fa-arrow-down"></i></span><span
																						class="decoration-icon"><i
																							class="fas fa-chevron-right"></i></span></a>
																			</li>
																		</ul>
																	</div>
																</div>
															</div>
														</div>
														<div class="wrap mcb-wrap mcb-wrap-2acfce73c three-fifth tablet-three-fifth mobile-one clearfix"
															data-desktop-col="three-fifth"
															data-tablet-col="tablet-three-fifth"
															data-mobile-col="mobile-one">
															<div class="mcb-wrap-inner mcb-wrap-inner-2acfce73c">
																<div class="mcb-wrap-background-overlay"></div>
																<div
																	class="column mcb-column mcb-item-9a6e579ed one tablet-one mobile-one column_heading">
																	<div
																		class="mcb-column-inner mcb-column-inner-9a6e579ed mcb-item-heading-inner">
																		<h6 class="title">WE RECOMMEND</h6>
																	</div>
																</div>
																<div
																	class="column mcb-column mcb-item-00d9f36ec one tablet-one mobile-one column_column">
																	<div
																		class="mcb-column-inner mcb-column-inner-00d9f36ec mcb-item-column-inner">
																		<div
																			class="column_attr mfn-inline-editor clearfix">
																			Fancy chair</div>
																	</div>
																</div>
																<div
																	class="column mcb-column mcb-item-c653fff55 one tablet-one mobile-one column_column">
																	<div
																		class="mcb-column-inner mcb-column-inner-c653fff55 mcb-item-column-inner">
																		<div
																			class="column_attr mfn-inline-editor clearfix">
																			Rutrum non id sem turpis
																			elementum vel id. Magna.</div>
																	</div>
																</div>
																<div
																	class="column mcb-column mcb-item-1ed2cd39a one tablet-one mobile-one column_column">
																	<div
																		class="mcb-column-inner mcb-column-inner-1ed2cd39a mcb-item-column-inner">
																		<div
																			class="column_attr mfn-inline-editor clearfix">
																			$1550.00</div>
																	</div>
																</div>
																<div
																	class="column mcb-column mcb-item-hlnhan32g one tablet-one mobile-one column_image mfn-column-absolute">
																	<div
																		class="mcb-column-inner mcb-column-inner-hlnhan32g mcb-item-image-inner">
																		<div
																			class="image_frame element_classes image_item no_link scale-with-grid alignnone no_border">
																			<div class="image_wrapper"><img
																					class="scale-with-grid"
																					src="https://themes.muffingroup.com/be/furniturestore/wp-content/uploads/2022/06/furniturestore-megamenu-pic1.webp"
																					alt="furniturestore-megamenu-pic1"
																					title="" width="600" height="600" />
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</li>

								</ul>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<script>
	document.addEventListener('DOMContentLoaded', function () {
		const header = document.getElementById('main-header');
		const body = document.body;

		if (!header) {
			console.error('Sticky Header: #mfn-header-template not found');
			return;
		}

		window.addEventListener('scroll', function () {
			console.log('ScrollY:', window.scrollY);
			if (window.scrollY > 100) {
				header.classList.add('sticky-header');
				body.classList.add('has-sticky-header');
			} else {
				header.classList.remove('sticky-header');
				body.classList.remove('has-sticky-header');
			}
		});
	});
</script>










<!-- /HEADER -->

<!-- NAVIGATION -->
<!-- <nav id="navigation"> -->
<!-- container -->
<!-- <div class="container"> -->
<!-- responsive-nav -->
<!-- <div id="responsive-nav"> -->
<!-- NAV -->
<!-- <ul class="main-nav nav py-3">
        <li class="active"><a routerLink="/">Home</a></li>
      </ul> -->
<!-- /NAV -->
<!-- </div> -->
<!-- /responsive-nav -->
<!-- </div> -->
<!-- /container -->
<!-- </nav> -->
<!-- /NAVIGATION -->




<!--


<header>
  
  <div id="top-header">
    <div class="container">
      <ul class="header-links pull-left">
        <li><a routerLink="#"><i class="fa fa-phone"></i> +0211-355-021</a></li>
        <li><a routerLink="#"><i class="fa fa-envelope-o"></i> email@email2021.com</a></li>
        <li><a routerLink="#"><i class="fa fa-map-marker"></i> 2021 FMI's Hell Road</a></li>
      </ul>
      <ul class="header-links pull-right">
        <li><a routerLink="#"><i class="fa fa-euro"></i> EUR</a></li>
        <li><a routerLink="#"><i class="fa fa-user-o"></i> My Account</a></li>
      </ul>
    </div>
  </div>
  

  
  <div id="header">
    
    <div class="container">
      
      <div class="row">
        
        <div class="col-md-3">
          <div class="header-logo">
            <a routerLink="#" class="logo">
              <img src="/assets/img/logo.png" alt="">
            </a>
          </div>
        </div>
        

      
        
        <div class="col-md-6">
          <div class="header-search">
            <form>
              <select class="input-select">
                <option value="0">All Categories</option>
                <option value="1">Category 01</option>
                <option value="1">Category 02</option>
              </select>
              <input class="input" placeholder="Search here">
              <button class="search-btn">Search</button>
            </form>
          </div>
        </div>
        -->
<!-- /SEARCH BAR -->


<!-- ACCOUNT -->
<!--<div class="col-md-9 clearfix">
          <div class="header-ctn">

            Whislist
            <div>
              <a routerLink="#">
                <i class="fa fa-heart-o"></i>
                <span>Your Wishlist</span>
                <div class="qty">0</div>
              </a>
            </div>
           

			
			
            
            <div class="dropdown" >
              <a class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true" style="cursor: pointer;">
                <i class="fa fa-shopping-cart"></i>
                <span>Your Cart</span>
                <div class="qty">{{cartData.data[0].numInCart !== 0 ? cartData.data.length : 0}}</div>
              </a>
              <div class="cart-dropdown" >
                <div class="cart-list" *ngIf="cartData.data[0].numInCart !== 0">
                  <div class="product-widget" *ngFor="let c of cartData.data; let i=index">
                    <div class="product-img">
                      <img src="{{c.product?.image}}" alt="" width="20px">
                    </div>
                    <div class="product-body">
                      <h3 class="product-name"><a routerLink="#">{{c.product?.name}}</a></h3>
                      <h4 class="product-price"><span class="qty">{{c.numInCart}} x </span>{{c.product?.price | currency:'EUR'}}</h4>
                    </div>
                    <button class="delete" (click)="cartService.DeleteProductFromCart(i)"><i class="fa fa-close"></i></button>
                  </div>


                </div>
                <div class="cart-summary">
                  <small>{{cartData.data[0].numInCart !== 0 ? cartData.data.length : 0}} Item(s) selected</small>
                  <h5>TOTAL : {{cartTotal | currency:'EUR'}}</h5>
                </div>
                <div class="cart-btns">
                  <a routerLink="/cart">View Cart</a>
                  <a routerLink="/checkout">Checkout <i class="fa fa-arrow-circle-right"></i></a>
                </div>
              </div>
            </div>
            

          
            <div class="menu-toggle">
              <a routerLink="#">
                <i class="fa fa-bars"></i>
                <span>Menu</span>
              </a>
            </div>
            
          </div>
        </div>
      
      </div>
    
    </div>
  
  </div>
  
</header>


-->


<!-- Scroll to Top Button -->
<button class="scroll-to-top" *ngIf="showScrollToTop" (click)="scrollToTop()" title="Scroll to top">
	↑
</button>